import React from 'react';

import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '../../utils/classUtils';

export interface SidebarModalProps {
  title?: string;
  subtitle?: string;
  isOpen: boolean;
  onClose(): void;
  size?: 'md' | 'lg';
  displayLeft?: boolean;
  closeIcon?: boolean;
  children?: React.ReactNode;
}

const SizeMap = {
  md: 'lg:w-[650px]',
  lg: 'lg:w-[1091px]',
};

const SidebarModal: React.FC<SidebarModalProps> = ({
  title,
  subtitle,
  isOpen,
  onClose,
  children,
  size = 'md',
  displayLeft = false,
  closeIcon = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const buttonClose = closeIcon ? 'py-0' : 'py-4';
  const alignmentClass = displayLeft ? 'mr-auto' : 'ml-auto';
  const slideAnimationDirection = displayLeft
    ? 'lg:animate-slide-in-left'
    : 'lg:animate-slide-in-right';

  return (
    <div
      className='fixed top-0 bottom-0 left-0 right-0 z-300 w-full text-gray-600 h-full-window'
      title='sidebar'
    >
      <div
        className='absolute top-0 bottom-0 left-0 right-0 z-0 hidden bg-black lg:block bg-opacity-40'
        role='button'
        onClick={onClose}
        title='close'
      />
      <div
        className={cn(
          `relative bg-white flex flex-col w-full h-full ${alignmentClass} animate-slide-in-up ${slideAnimationDirection}`,
          SizeMap[size],
        )}
      >
        <div
          className={`flex items-center justify-between px-5 ${buttonClose} bg-blue-100`}
        >
          <div className='space-y-1.5'>
            {title && (
              <h2 className='text-md font-inter font-bold text-zen-dark-9 tracking-wide'>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className='text-[15px] text-gray-600'>{subtitle}</p>
            )}
          </div>
          {!closeIcon && (
            <button
              onClick={onClose}
              title='Close'
              className='h-6 w-6 flex items-center justify-center bg-[#B2BDC6] rounded-full p-1'
              data-testid='close-modal'
            >
              <FontAwesomeIcon icon={faXmark} className='text-white' />
            </button>
          )}
        </div>
        <div className='h-full scrollbar overflow-y-auto' id='modal-scroll'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default SidebarModal;
